













import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import Question from '../models/Question'
import { State, Getter, Action, Mutation } from '../store-helper'
import markdownParser from '../../../helpers/markdown-parser'
import { IQuestionSkill } from '../types'

@Component({})

export default class SkillPreviewComponent extends Vue {
  @Prop() question: Question

  public get skills(): IQuestionSkill {
    return this.question.skills
  }
}
